module.exports = __webpack_public_path__ + "static/media/11.8db1add7.JPG";